<template>
  <div>
    <header-search-mobile
      ref="header-search-mobile"
      v-model="search"
      class="headerMobileSearch"
      placeholder="Height / address / block hash / transaction hash"
      @change="handlerSearch"
    />
    <header-search-desktop
      v-model="search"
      class="headerDesktopSearch"
      placeholder="Height / address / block hash / transaction hash"
      @change="handlerSearch"
    />
    <header-search-popup v-if="error" @close="handlePopupClose" />
  </div>
</template>

<script>
import HeaderSearchMobile from './components/HeaderSearchMobile'
import HeaderSearchDesktop from './components/HeaderSearchDesktop'
import HeaderSearchPopup from './components/HeaderSearchPopup'
import { getBlock, getIdentify } from '@/services/api'

export default {
  name: 'HeaderSearch',
  components: { HeaderSearchPopup, HeaderSearchDesktop, HeaderSearchMobile },
  data() {
    return {
      error: '',
      search: '',
    }
  },
  methods: {
    async handlerSearch() {
      if (!this.search.length) return

      const { data } = await getIdentify(this.search)
      if (data.state === 'success') {
        const type = data.data.type
        const name =
          type === 'BLOCK'
            ? 'Block'
            : type === 'TX'
            ? 'Transaction'
            : type === 'ADDRESS'
            ? 'Address'
            : 'NotFound'
        if (name !== 'NotFound') {
          await this.$router.push({ name, params: { id: this.search } })
        } else {
          if (!isNaN(+new Date(this.search))) {
            const timeOfBlockZero = await this.getTimeOfBlockZero()
            const search = +new Date(this.search)
            if (search > timeOfBlockZero && search < +new Date()) {
              await this.$router.push({ name: 'BlocksSearch', params: { time: this.search } })
            }
          } else if (
            [
              'STANDARD',
              'MINTING',
              'MINTING_CONTRACT',
              'COINBASE',
              'ACTIVATION',
              'FUNDING_CONTRACT',
              'BOT_CONTRACT',
              'BOT_CONTRACT_DEACTIVATION',
              'DEAL_CONTRACT',
              'PLATINCOIN_CONTRACT',
            ].includes(this.search.toUpperCase())
          ) {
            await this.$router.push({ name: 'Blocks', query: { type: this.search } })
          } else {
            this.error = `We couldn't find what you are looking for.`
          }
        }
      } else {
        this.error = `We couldn't find what you are looking for.`
      }

      this.$refs['header-search-mobile'].toggleSearch()
      this.search = ''
    },
    async getTimeOfBlockZero() {
      const { data } = await getBlock(0, true) // 1519862400000 = time of 0 block
      return data.state === 'success' ? data.data.time : 0
    },
    handlePopupClose() {
      this.error = ''
    },
  },
}
</script>

<style lang="scss" scoped>
.headerMobileSearch {
  @media (min-width: $breakpoint-lg) {
    display: none;
  }
}

.headerDesktopSearch {
  @media (max-width: $breakpoint-lg - 1px) {
    display: none;
  }
}
</style>
